/* Package JSON Import will be here */
import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
/* Package JSON Import will be here */

/* Project Import will be here */
import loginReducer from './login.Reducer';
/* Project Import will be here */   

export default combineReducers({
    router: routerReducer,
    loginReducer
});